"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unBookSeat = exports.checkSeatBooked = exports.checkSeatReserved = exports.checkSeatDisabled = exports.checkSeatAbsent = exports.checkSeatClickableForEdit = exports.checkSeatClickableForSelect = exports.NOT_CLICKABLE_FOR_EDIT = exports.NOT_CLICKABLE_FOR_SELECT = exports.SEAT_ERROR = exports.SEAT_MARKED = exports.SEAT_SELECTED = exports.SEAT_ABSENT = exports.SEAT_BOOKED = exports.SEAT_PREBOOKED = exports.SEAT_RESERVED = exports.SEAT_DISABLED = exports.SEAT_EXISTS = void 0;
exports.SEAT_EXISTS = 0;
exports.SEAT_DISABLED = 1;
exports.SEAT_RESERVED = 2;
exports.SEAT_PREBOOKED = 4;
exports.SEAT_BOOKED = 8;
exports.SEAT_ABSENT = 32;
exports.SEAT_SELECTED = 128;
exports.SEAT_MARKED = 256;
exports.SEAT_ERROR = 1024;
exports.NOT_CLICKABLE_FOR_SELECT = exports.SEAT_ABSENT | exports.SEAT_DISABLED | exports.SEAT_RESERVED | exports.SEAT_PREBOOKED | exports.SEAT_BOOKED;
exports.NOT_CLICKABLE_FOR_EDIT = exports.SEAT_PREBOOKED | exports.SEAT_BOOKED;
// TODO perhaps should be moved to front as business logic
const checkSeatClickableForSelect = (seat) => {
    return !(seat & exports.NOT_CLICKABLE_FOR_SELECT);
};
exports.checkSeatClickableForSelect = checkSeatClickableForSelect;
// TODO perhaps should be moved to front as business logic
const checkSeatClickableForEdit = (seat) => {
    return !(seat & exports.NOT_CLICKABLE_FOR_EDIT);
};
exports.checkSeatClickableForEdit = checkSeatClickableForEdit;
const checkSeatAbsent = (seat) => {
    return !!(seat & exports.SEAT_ABSENT);
};
exports.checkSeatAbsent = checkSeatAbsent;
const checkSeatDisabled = (seat) => {
    return !!(seat & exports.SEAT_DISABLED);
};
exports.checkSeatDisabled = checkSeatDisabled;
const checkSeatReserved = (seat) => {
    return !!(seat & exports.SEAT_RESERVED);
};
exports.checkSeatReserved = checkSeatReserved;
const checkSeatBooked = (seat) => {
    return !!(seat & (exports.SEAT_PREBOOKED | exports.SEAT_BOOKED));
};
exports.checkSeatBooked = checkSeatBooked;
const unBookSeat = (seat) => {
    return seat & ~(exports.SEAT_PREBOOKED | exports.SEAT_BOOKED);
};
exports.unBookSeat = unBookSeat;
//# sourceMappingURL=config.js.map